import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';

type Props = {
  handleCloseModal: () => void;
};

const UpdateSharesHeader: FC<Props> = ({ handleCloseModal }) => {
  const { t } = useTranslate();

  return (
    <Modal.Header>
      <h5 className="mb-0">{t('UpdateShare')}</h5>
      <a className="close cursor-pointer" onClick={handleCloseModal}>
        <em className="icon ni ni-cross" />
      </a>
    </Modal.Header>
  );
};

export default UpdateSharesHeader;
